module.exports = __webpack_public_path__ + "static/media/onboard.3d5fe086.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Signup/onboard.png
// module id = 2786
// module chunks = 0